// src/components/dev/utils/Footer/Footer.tsx
import React from "react";
import { StyledFooter, SitemapSection, SitemapList, SitemapLink, MainFooter } from "./Footer.styled";
import { Button } from "antd";

const Footer: React.FC = () => {
  return (
    <StyledFooter role="contentinfo">
      {/* Sitemap Section (Upper Footer) */}
      <SitemapSection>
        {/* Row 1 */}
        <SitemapList>
          <SitemapLink href="https://www.olsme.com/lightScience" aria-label="Go to About Us page">
            About Us
          </SitemapLink>
          <SitemapLink href="https://www.olsme.com/OLSaeo" aria-label="Go to OLS iee.aeo page">
            OLS iee.aeo
          </SitemapLink>
          <SitemapLink href="https://www.olsme.com/OLSstudentProspect" aria-label="Go to OLS prospect student page">
            OLS prospect student
          </SitemapLink>
          <SitemapLink href="https://www.olsme.com/Stat" aria-label="Go to OLSstat page">
            OLSstat
          </SitemapLink>
        </SitemapList>

        {/* Row 2 */}
        <SitemapList>
          <SitemapLink href="https://www.olsme.com/olsupdates" aria-label="Go to Updates page">
            Updates
          </SitemapLink>
          <SitemapLink href="https://www.olsme.com/OLSinventions" aria-label="Go to OLS Inventions page">
            OLS Inventions
          </SitemapLink>
          <SitemapLink href="https://www.olsme.com/estate" aria-label="Go to OLS Marketplace /estate page">
            Marketplace /estate
          </SitemapLink>
          <SitemapLink href="https://www.olsme.com/olsme" aria-label="Go to OLSME page">
            OLSME
          </SitemapLink>
        </SitemapList>

        {/* Row 3 */}
        <SitemapList>
          <SitemapLink href="https://www.olsme.com/aOLSLMasset" aria-label="Go to OLSLM assets page">
            OLSLM assets
          </SitemapLink>
          <SitemapLink href="https://www.olsme.com/referral" aria-label="Go to OLS Referral Program page">
            Referral Program
          </SitemapLink>
          <SitemapLink href="https://www.olsme.com/contact" aria-label="Go to Contact Us page">
            Contact Us
          </SitemapLink>
          <SitemapLink href="https://www.olsme.com/OLScalendarTime" aria-label="Go to OLS Calendar Time page">
            OLS Calendar Time
          </SitemapLink>
        </SitemapList>

        {/* Row 4 */}
        <SitemapList>
          <SitemapLink href="https://www.olsme.com/OLShealth" aria-label="Go to OLS Health page">
            OLS Health
          </SitemapLink>
          <SitemapLink href="https://www.olsme.com/privacy" aria-label="Go to OLS private privacy page">
            OLS private privacy
          </SitemapLink>
          <SitemapLink href="https://www.olsme.com/olsdataprovision" aria-label="Go to OLS Data Provision page">
            Data Provision 
          </SitemapLink>
          <SitemapLink href="https://www.olsme.com/olshealth/packages" aria-label="Go to OLS Health Packages page">
            OLS Packages
          </SitemapLink>
          {/* This row will have 3 items, leaving the 4th column spot visually empty */}
        </SitemapList>

      </SitemapSection>

      {/* Main Footer Content */}
      <MainFooter>
        <Button
          href="https://www.olsme.com"
          type="link"
          aria-label="Visit OLS homepage"
          style={{ color: "#0427f4" }}
        >
          onelightsystemOLS®© LLC CA USA
        </Button>
        <span style={{ color: "#0427f4" }}>since 3397-3405 (2017 - 2025)</span>
        <Button
          href="https://www.olsme.com/privacy"
          type="link"
          aria-label="View Terms of Use"
          style={{ color: "#0427f4" }}
        >
          Terms of Use
        </Button>
        <span style={{ color: "#0427f4" }}>download iOS app (coming soon)</span>
      </MainFooter>
    </StyledFooter>
  );
};

export default Footer;